import { ProductTierSku } from '@vendia/management-api-types'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import { LinkItem, SideNavLinkItem } from 'src/components/navigation/side-nav-link-item'
import { useGetOrg } from 'src/utils/hooks/use-get-org'
import { useIsEnterpriseOrgMember } from 'src/utils/hooks/use-is-org-member'

export function HomeSideNav({ hideBorder = false }: { hideBorder?: boolean }) {
  const { data: isEnterprise } = useIsEnterpriseOrgMember()
  const getOrg = useGetOrg()
  const productTierSku = getOrg?.data?.getOrganization?.productTier?.sku

  // Product tier takes priority over share tier for determining MCP vs Enterprise UI
  const showMcpUI = productTierSku
    ? productTierSku === ProductTierSku.Individual || productTierSku === ProductTierSku.Pro
    : !isEnterprise

  const links: LinkItem[] = [
    {
      path: `/`,
      label: 'Home',
      iconName: 'lucide-house',
    },
    {
      path: `/data-products`,
      label: 'Data Products',
      iconName: 'lucide-box',
    },
    {
      isDivider: true,
    },
    {
      path: '/org/overview',
      label: 'Admin',
      iconName: 'lucide-shield',
    },
    {
      path: `/settings`,
      label: 'Account',
      iconName: 'lucide-user',
    },
    {
      path: `https://docs.vendia.com/`,
      label: 'Documentation',
      iconName: 'lucide-book-open',
      isExternal: true,
    },
  ]

  const enterpriseLinks: LinkItem[] = [
    {
      path: `/`,
      label: 'Home',
      iconName: 'lucide-house',
    },
    {
      path: `/uni`,
      label: 'Projects',
      iconName: 'lucide-network',
    },
    {
      path: `/data-products`,
      label: 'Data Products',
      iconName: 'lucide-box',
    },
    {
      isDivider: true,
    },
    {
      path: '/org/overview',
      label: 'Organization',
      iconName: 'lucide-shield',
    },
    {
      path: `/settings`,
      label: 'Account',
      iconName: 'lucide-user',
    },
    {
      path: `https://docs.vendia.com/`,
      label: 'Documentation',
      iconName: 'lucide-book-open',
      isExternal: true,
    },
  ]

  const currentLinks = showMcpUI ? links : enterpriseLinks

  const location = useLocation()
  const linkListItems = currentLinks?.map((link, index) => {
    const basePath = ''
    const path = `${basePath}${link.path}`
    // Normalize trailing slash and compare to find active path
    const currentPath = location.pathname.replace(/\/+$/, '')
    const currentLinkPath = path.replace(/\/+$/, '')
    const isActive =
      currentPath === '' || currentLinkPath === ''
        ? currentPath === currentLinkPath
        : currentPath.includes(currentLinkPath)
    link.isActive = isActive
    link.path = path

    return <SideNavLinkItem key={`${path}-${index}`} linkItem={link} />
  })

  return (
    <div
      className={clsx('max-h-[calc(100vh-76px)] overflow-y-auto p-4', !hideBorder && 'border-t border-slate-200 pt-8')}
    >
      {linkListItems}
    </div>
  )
}
